import { Button, Card, Col, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import "./Vehicles.css";
import { years } from "../../../../utils/tenants";
import { toast } from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";

function Vehicles({ data }) {
  const [checked, setChecked] = useState(false);
  const [vehicles, setVehicles] = useState([
    {
      id: uuidv4(),
      make: "",
      model: "",
      color: "",
      licenseNumber: "",
      year: "",
      permitNumber: "",
    },
  ]);

  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(db, "companies", companyName, "tenants");
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label: doc.data().propertyGroupName,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find(
            (item) => item.id === data?.id
          );
          setVehicles(
            filteredTenant?.vehicles?.length >= 1
              ? filteredTenant?.vehicles
              : [
                  {
                    id: uuidv4(),
                    make: "",
                    model: "",
                    color: "",
                    licenseNumber: "",
                    year: "",
                    permitNumber: "",
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, checked]);

  const addVehicle = () => {
    const newVehicle = {
      id: uuidv4(),
      make: "",
      model: "",
      color: "",
      licenseNumber: "",
      year: "",
      permitNumber: "",
    };
    setVehicles([...vehicles, newVehicle]);
  };

  const removeVehicle = (id) => {
    const updatedVehicles = vehicles.filter((vehicle) => vehicle.id !== id);
    setVehicles(updatedVehicles);
  };

  const handleChange = (value, name, id) => {
    const updatedVehicles = vehicles.map((vehicle) => {
      if (vehicle.id === id) {
        return { ...vehicle, [name]: value };
      }
      return vehicle;
    });
    setVehicles(updatedVehicles);
  };

  const addVehicles = () => {
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      const filteredVehicles = vehicles.filter((item) => {
        return Object.keys(item).some(
          (key) => key !== "id" && item[key] !== ""
        );
      });
      const vehiclesObj = {
        vehicles: filteredVehicles,
      };
      updateDoc(tenantRef, vehiclesObj);
      setChecked(false);
      toast.success("Tenant vehicle info updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  return (
    <Row className="vehicles">
      <Col span={24}>
        <Card
          title="Vehicles"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={4}>
                    <span>Make</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>Model</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>Color</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>License #</span>
                  </Col>
                  <Col className="header-row" span={3}>
                    <span>Year</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>Permit Number</span>
                  </Col>
                </Row>
              </Col>
              {vehicles.length >= 1 && vehicles
                ? vehicles.map((item, index) => {
                    return (
                      <Col span={24} key={index}>
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={4}>
                            <Input
                              placeholder="Make"
                              value={item.make}
                              onChange={(e) =>
                                handleChange(e.target.value, "make", item.id)
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <Input
                              placeholder="Model"
                              value={item.model}
                              onChange={(e) =>
                                handleChange(e.target.value, "model", item.id)
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <Input
                              placeholder="Color"
                              value={item.color}
                              onChange={(e) =>
                                handleChange(e.target.value, "color", item.id)
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <Input
                              placeholder="License Number"
                              value={item.licenseNumber}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  "licenseNumber",
                                  item.id
                                )
                              }
                            />
                          </Col>
                          <Col span={3}>
                            <Select
                              options={years}
                              placeholder="Select..."
                              value={item.year}
                              onChange={(value) =>
                                handleChange(value, "year", item.id)
                              }
                            />
                          </Col>
                          <Col span={4}>
                            <Input
                              placeholder="Permit Number"
                              value={item.permitNumber}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  "permitNumber",
                                  item.id
                                )
                              }
                            />
                          </Col>
                          {vehicles.length > 1 ? (
                            <Col span={1}>
                              <CgCloseO
                                className="delete-btn"
                                size={20}
                                onClick={() => removeVehicle(item.id)}
                              />
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    );
                  })
                : null}
              <Col span={24}>
                <button onClick={() => addVehicle()} className="add-icon-btn">
                  <RiAddCircleFill size={18} />
                  <span>Add Another Vehicle</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary" onClick={() => addVehicles()}>
                      Save
                    </Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.vehicles?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={4}>
                          <span>Make</span>
                        </Col>
                        <Col span={4}>
                          <span>Model</span>
                        </Col>
                        <Col span={4}>
                          <span>Color</span>
                        </Col>
                        <Col span={4}>
                          <span>License #</span>
                        </Col>
                        <Col span={4}>
                          <span>Year</span>
                        </Col>
                        <Col span={4}>
                          <span>Permit Number</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.vehicles.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={4}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.model}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.color}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.licenseNo}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.year}</span>
                        </Col>
                        <Col span={4}>
                          <span>{item.permitNumber}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>Click edit to add vehicles.</p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Vehicles;
